export enum DefaultValues {
  REQUISITION_STATUS_DEFAULT = 'Open',
}
